/** Stockfish search times (movetime ms) — bar uses full-strength eval (no Skill Level). */

/** Side eval bar after each move. */
export const CHESS_EVAL_BAR_MOVETIME_MS = 1200;

/** Move review: eval after your move. */
export const CHESS_EVAL_REVIEW_AFTER_MS = 900;

/** Move review: engine best move from position before your move. */
export const CHESS_EVAL_REVIEW_BEST_MS = 2200;
